import { render } from "./PlanetDesktop.vue?vue&type=template&id=334bc1ce&scoped=true"
import script from "./PlanetDesktop.vue?vue&type=script&lang=ts"
export * from "./PlanetDesktop.vue?vue&type=script&lang=ts"

import "./PlanetDesktop.vue?vue&type=style&index=0&id=334bc1ce&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-334bc1ce"

export default script